module.exports = "/_next/static/images/c27043f910aa71f0dd19656be9fb6e8f-mulher-perfil-segurando-cartao-lg@3x.jpg";